import { useEffect, useState } from 'react';
import { fetchBuSummary } from './buSummary';

// Cross-BU metrics keyed by MID. One call covers the whole table, so this is
// fetched once per mount of the comparison page.
export function useBuSummary() {
    const [metrics, setMetrics] = useState({});
    const [loading, setLoading] = useState(true);
    const [error,   setError]   = useState(null);

    useEffect(() => {
        let alive = true;

        fetchBuSummary()
            .then(byMid => {
                if (!alive) return;
                setMetrics(byMid);
                setError(null);
            })
            .catch(err => {
                if (!alive) return;
                setError(err.response?.data?.message || err.message || 'Request failed');
            })
            .finally(() => { if (alive) setLoading(false); });

        return () => { alive = false; };
    }, []);

    return { metrics, loading, error };
}
